import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { NgxSpinner, NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { BlogTags } from '../../_shared/_enums/blog-tags';
import { ProductCategories } from '../../_shared/_enums/product-categories';
import { BlogService } from '../../_shared/_services/blog.service';
import { PrismicService } from '../../_shared/_services/prismic.service';
import { IBlogPost } from '../_prismic/blog-post';
import { ImageComponent } from '../../_shared/_components/image/image.component';
import { AsyncPipe, UpperCasePipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-pool-care-info',
    templateUrl: './pool-care-info.component.html',
    styleUrls: ['./pool-care-info.component.scss'],
    imports: [NgxSpinnerComponent, ImageComponent, AsyncPipe, UpperCasePipe, DatePipe]
})
export class PoolCareInfoComponent implements OnInit, OnDestroy {
  private readonly prismicService = inject(PrismicService);
  private readonly blogService = inject(BlogService);
  private readonly ngxSpinnerService = inject(NgxSpinnerService);

  public spinner$: Observable<NgxSpinner>;
  public blogPost!: IBlogPost;
  private readonly blogTags = BlogTags;
  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  constructor() {
    const ngxSpinnerService = this.ngxSpinnerService;

    this.spinner$ = ngxSpinnerService.spinnerObservable;
  }

  public async ngOnInit(): Promise<void> {
    await this.ngxSpinnerService.show();
    this.blogService.blogs$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(async (blogs: Array<IBlogPost>) => {
        const index = blogs.findIndex(b => b.tag === this.blogTags.POOL_CARE_101);
        if (index > -1) {
          this.blogPost = blogs[index];
          await this.ngxSpinnerService.hide();
        } else {
          this.blogService.loadBlogs();
        }
      });
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
